import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { authTranslations } from '@teletienda/shared-auth-ui';

// Supported languages
export const SUPPORTED_LANGUAGES = ['es', 'en', 'pt', 'ru'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

// Language names for display
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  es: 'Español',
  en: 'English',
  pt: 'Português',
  ru: 'Русский',
};

// Build resources object with auth translations included
const resources = {
  es: { auth: authTranslations.es.auth },
  en: { auth: authTranslations.en.auth },
  pt: { auth: authTranslations.pt.auth },
  ru: { auth: authTranslations.ru.auth },
};

// Initialize i18next and export the promise for awaiting
export const i18nInitPromise = i18n
  // Load translations from /public/locales
  .use(HttpBackend)
  // Detect user language
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    // Default language
    fallbackLng: 'es',

    // Supported languages
    supportedLngs: SUPPORTED_LANGUAGES,

    // Pre-load auth namespace from shared-auth-ui (bundled, not HTTP loaded)
    resources,

    // Namespaces - 'auth' is bundled via resources (not in ns to avoid HttpBackend 404)
    // Other namespaces loaded via HttpBackend from /locales/
    ns: ['common', 'errors', 'catalog'],
    defaultNS: 'common',

    // Partial bundle - allows mixing bundled resources with HTTP backend
    partialBundledLanguages: true,

    // Backend configuration
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // React already escapes values
    interpolation: {
      escapeValue: false,
    },

    // Language detection
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    // Debug mode (only in development)
    debug: import.meta.env.DEV,

    // React-specific - use Suspense for lazy loading translations
    react: {
      useSuspense: true,
    },
  });

export default i18n;
